/**
 * Handle Cookie via JS
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 * @returns {null|string} - The cookie value or null if not found
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	let name;

	const nameEQ = `${name}=`;
	const cookies = document.cookie.split(';');

	for (let cookie of cookies) {
		cookie = cookie.trim();

		if (debug) console.log(cookie);

		if (cookie.startsWith(nameEQ)) {
			return cookie.substring(nameEQ.length);
		}
	}

	return null;
};
